import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const accountsQueryAtom = createQueryAtomFactory(
  'trade.accounts',
  (params: { searchTerm: string; offset?: number; limit?: number }) => ({
    accounts: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 10,
        },
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        name: true,
        type: true,
        email: true,
        phone: true,
        website: true,
        relationship: {
          isCustomer: true,
          isSupplier: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
        accountManagers: {
          id: true,
          firstName: true,
          lastName: true,
        },
        addresses: {
          id: true,
          name: true,
          address: {
            addressType: true,
            streetAddress: true,
            city: true,
            state: true,
            postalCode: true,
            country: true,
            isMailingAddress: true,
          },
          contacts: {
            id: true,
            fullName: true,
            email: true,
            phone: true,
            isPrimary: true,
            timestamps: {
              createdAt: true,
              updatedAt: true,
            },
          },
        },
      },
    },
  }),
  {
    select: (data) => ({
      accounts:
        data?.accounts.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
          type: entry.type,
          email: entry.email ?? undefined,
          phone: entry.phone ?? undefined,
          website: entry.website ?? undefined,
          relationship: {
            isCustomer: entry.relationship?.isCustomer ?? false,
            isSupplier: entry.relationship?.isSupplier ?? false,
          },
          addresses: entry.addresses.map((a) => ({
            id: a.id,
            name: a.name ?? '',
            ...a.address,
            contacts: a.contacts,
          })),
          purchasesVolume: [],
          salesVolume: [],
          timestamps: entry.timestamps,
          accountManagerIds: entry.accountManagers?.map((m) => m.id) ?? [],
        })) ?? [],
      total: data?.accounts.page.total ?? undefined,
    }),
  },
);
